import { Box, CircularProgress, IconButton, TextField, Typography, Button } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';

const ComentarioForm = ({
    replyTo,
    onCancelReply,
    newComment,
    onChangeNewComment,
    onSubmit,
    submitting,
    maxCommentLength,
}) => {
    const hasValidContent = newComment.trim().length > 0 && newComment.length <= maxCommentLength;

    return (
        <>
            {replyTo && (
                <Box
                    sx={{
                        mb: 1,
                        p: 1,
                        borderRadius: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant="caption" color="text.secondary">
                        Respondiendo a @{replyTo.nickname}
                    </Typography>
                    <Button size="small" onClick={onCancelReply}>
                        Cancelar
                    </Button>
                </Box>
            )}

            <Box
                sx={{
                    position: 'relative',
                    borderRadius: 2,
                    border: 1,
                    borderColor: 'divider',
                    px: 1.5,
                    pt: 1.5,
                    pb: 5.5,
                    mb: 2,
                }}
            >
                <TextField
                    fullWidth
                    multiline
                    minRows={1}
                    maxRows={8}
                    placeholder="Escribe tu comentario..."
                    value={newComment}
                    onChange={(e) => onChangeNewComment(e.target.value)}
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    sx={{
                        '& .MuiInputBase-root': {
                            fontSize: { xs: '16px', sm: '14px' },
                            lineHeight: 1.4,
                        },
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && e.ctrlKey && hasValidContent && !submitting) {
                            onSubmit();
                        }
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 8,
                        left: 16,
                        right: 16,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 1,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '11px',
                            color:
                                newComment.length > maxCommentLength - 20 ? 'error.main' : 'text.secondary',
                        }}
                    >
                        {newComment.length}/{maxCommentLength}
                    </Typography>
                    <IconButton
                        onClick={(e) => {
                            e.preventDefault();
                            if (hasValidContent && !submitting) {
                                onSubmit();
                            }
                        }}
                        disabled={!hasValidContent || submitting}
                        sx={{
                            bgcolor: hasValidContent ? 'background.darkCard' : 'transparent',
                            color: '#ccc',
                            border: '1px solid',
                            borderColor: 'border.main',
                            '&:hover': {
                                bgcolor: hasValidContent ? 'action.hover' : 'transparent',
                            },
                        }}
                    >
                        {submitting ? <CircularProgress size={20} /> : <ArrowUpwardRoundedIcon />}
                    </IconButton>
                </Box>
            </Box>
        </>
    );
};

export default ComentarioForm;
